import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from '@shopify/polaris'
import styled from 'styled-components'
import generate from 'firebase-auto-ids'
import now from 'lodash/now'
import get from 'lodash/get'
import values from 'lodash/values'

import UICard from '../shopifyUI/UICard'
import ShopifyAssetsSelector from '../shopifyUI/ShopifyAssetsSelector'
import UploadAssetsButton from 'components/editor/assetsManager/UploadAssetsButton'

const ContentContainer = styled.div`
  margin-top: 1em;
`

class ChangeBackgroundImage extends Component {

  constructor (props) {
    super(props)
    this.state = {
      assets: this.makeAssetsFromAvailableProducts(props)
    }
  }

  makeAssetsFromAvailableProducts = (props) => {
    const { app, availableProducts } = props
    const res = {}
    for (const p of availableProducts) {
      const images = get(p, 'details.images', [])
      for (const url of images) {
        const id = generate(now())
        res[id] = {
          id: id,
          url: url
        }
      }
    }
    const appAssets = get(app, 'assets', {})
    return Object.assign(appAssets, res)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      assets: this.makeAssetsFromAvailableProducts(nextProps)
    })
  }

  renderRight () {
    const { onDone } = this.props
    return (
      <Button primary onClick={onDone} size='slim'>
        Done
      </Button>
    )
  }

  onCropResize = () => {
    const { toCropResizeStep } = this.props
    toCropResizeStep()
  }

  renderLeft () {
    return (
      <div>
        <Button size='slim' plain onClick={this.onCropResize}>
          Crop/resize
        </Button>
      </div>
    )
  }

  onAssetClick = (asset) => {
    // console.log('onAssetClick', asset)
    this.props.setShowcaseImage(asset.url)
  }

  renderContent () {
    const { app, currentImageUrl } = this.props
    return (
      <ContentContainer>
        <ShopifyAssetsSelector
          isVideo={false}
          currentValue={currentImageUrl}
          assets={this.state.assets}
          path={[]}
          appId={app.id}
          onAssetClick={this.onAssetClick}
        />
      </ContentContainer>
    )
  }

  onUploadAssetsClick = (e) => {
    if (this.uploadAssetsButtonRef) this.uploadAssetsButtonRef.getWrappedInstance().onClick()
  }

  uploadAssetsButtonMounted = (ref) => {
    this.uploadAssetsButtonRef = ref
  }

  render () {
    const { app } = this.props
    const uploadButton = (
      <UploadAssetsButton
        ref={this.uploadAssetsButtonMounted}
        appId={app.id}
        isVideo={false}
        useCropModal={false}
      >
        Upload Image
      </UploadAssetsButton>
    )
    const actions = [{content: uploadButton, onClick: this.onUploadAssetsClick}]
    return (
      <UICard
        title={'Select Background Image'}
        description={'First impressions matter, blow your customers away with a great looking background image.'}
        footerRight={this.renderRight()}
        footerLeft={this.renderLeft()}
        content={this.renderContent()}
        actions={actions}
      />
    )
  }
}

ChangeBackgroundImage.propTypes = {
  currentImageUrl: PropTypes.string,
  onDone: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  availableProducts: PropTypes.array.isRequired,
  setShowcaseImage: PropTypes.func.isRequired,
  toCropResizeStep: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    availableProducts: values(state.integrationProducts)
  }
}

export default connect(mapStateToProps)(ChangeBackgroundImage)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/productsSlideWizard/ChangeBackgroundImage.js